import { FC, ReactNode } from 'react';

import { FeaturesSettings } from '../../types/siteSettings';
import { useEnabledFeatures } from './FeaturesContext';

export interface FeatureToggleProps {
  featureName: keyof FeaturesSettings;
  children?: ReactNode;
}

export const FeatureToggle: FC<FeatureToggleProps> = ({ featureName, children }) => {
  const enabledFeatures = useEnabledFeatures();
  const featureSettings = enabledFeatures[featureName];
  if (!featureSettings) return null;

  return <>{children}</>;
};
